import React from 'react';
import I18n from 'utils/I18n';

import styles from './index.scss';
import whatsNewImage from './assets/whats-new.png';
import sportTypesImage from './assets/sport-types.png';
import deviceImage from './assets/device.png';
import FeatureCard from './components/FeatureCard';

const I18nPrefix = 'templates.account.feature_cards';

const FeatureCards = () => {
  const cards = [
    {
      img_src: whatsNewImage,
      header: I18n.t(`${I18nPrefix}.whats_new_header`),
      description: I18n.t(`${I18nPrefix}.whats_new_description`),
      link_copy: I18n.t(`${I18nPrefix}.whats_new_link_copy`),
      url: 'https://www.strava.com/whats-new'
    },
    {
      img_src: sportTypesImage,
      header: I18n.t(`${I18nPrefix}.sport_types_header`),
      description: I18n.t(`${I18nPrefix}.sport_types_description`),
      link_copy: I18n.t(`${I18nPrefix}.sport_types_link_copy`),
      url:
        'https://support.strava.com/hc/en-us/articles/216919407-Supported-Sport-Types-on-Strava'
    },
    {
      img_src: deviceImage,
      header: I18n.t(`${I18nPrefix}.devices_header`),
      description: I18n.t(`${I18nPrefix}.devices_description`),
      link_copy: I18n.t(`${I18nPrefix}.devices_link_copy`),
      url:
        'https://support.strava.com/hc/en-us/articles/223297187-How-to-get-your-Activities-to-Strava'
    }
  ];

  return (
    <section className={styles.container}>
      {cards.map((card) => (
        <FeatureCard card={card} key={card.header} />
      ))}
    </section>
  );
};

export default FeatureCards;
